import React from "react";
import Tribe from "../../../enum/Tribe";
import {isPlayableTribe} from "../../../Helper/Tribe";
import {ImageTribe} from "../../ImageMisc/ImageTribe";

import {useTranslationContext} from "../../../../react/providers/TranslationContext";
import WithTooltip from "../../../../react/components/ui/withTooltip";

type Props = {
    vid: Tribe[],
}

export function BuildingRequirementTribe({vid}: Props) {
    const { translate } = useTranslationContext();

    const playableTribes = Object.values(Tribe)
        .filter(value => typeof value === 'number')
        .filter((tribe: Tribe) => isPlayableTribe(tribe));
    const playableAllowedTribes = vid.filter(tribe => isPlayableTribe(tribe));

    if (playableTribes.length === playableAllowedTribes.length) {
        // All tribes can build this, no point in printing a requirement about it then.
        return <></>
    }

    if (playableAllowedTribes.length !== 1) {
        // Some buildings *looks at hospital* have requirements like that.
        return <div className='d-flex gap-2'>
            {
                vid.map((tribe: Tribe) => <div key={tribe}>
                    <WithTooltip tooltip={translate('tribe_vid' + tribe)}>
                        <ImageTribe tribe={tribe} size={24} />
                    </WithTooltip>
                </div>)
            }
        </div>
    }

    return <div className='d-flex align-items-center gap-2'>
        <ImageTribe tribe={vid[0]} size={24} />
        <div>
            {translate('tribe_vid' + vid[0])}
        </div>
    </div>
}
